<template>
  <div class="page-content">
     <div class="container-fluid">
        <!-- start page title -->
        <div class="row">
           <div class="col-12">
              <div class="page-title-box d-flex align-items-center justify-content-between">
                 <h4 class="mb-0 font-size-18">Your Servers </h4>
                 <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                       <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
                       <li class="breadcrumb-item active">Your Servers</li>
                    </ol>
                 </div>
              </div>
           </div>
        </div>
        <!-- end page title -->
        <div class="row" v-if="servers.length > 0">
           <div class="col-lg-12">
              <div class="">
                 <div class="table-responsive">
                    <table class="table project-list-table table-nowrap table-centered table-borderless">
                       <thead>
                          <tr>
                             <th scope="col">Status </th>
                             <th scope="col">Server IP</th>
                             <th scope="col">Tier</th>
                             <th scope="col">Action</th>
                          </tr>
                       </thead>
                       <tbody>
                          <tr>
                             <td>
                                <h5><span class="badge badge-danger">OFFLINE</span></h5>
                             </td>
                             <td>duckyserver.spc.mn</td>
                             <td><span class="badge badge-success">Free</span></td>
                             <td>
                                <a href="dashboard.html"><button type="button" class="btn btn-light waves-effect waves-light">
                                <i class="bx bx-toggle-right font-size-16 align-middle mr-2"></i> Manage
                                </button></a>
                             </td>
                          </tr>
                          <tr>
                             <td>
                                <h5><span class="badge badge-success">ONLINE</span></h5>
                             </td>
                             <td>45.34.44.112:25565</td>
                             <td><span class="badge badge-danger">Paid</span></td>
                             <td>
                                <button type="button" class="btn btn-light waves-effect waves-light">
                                <i class="bx bx-toggle-right font-size-16 align-middle mr-2"></i> Manage
                                </button>
                             </td>
                          </tr>
                       </tbody>
                    </table>
                 </div>
              </div>
           </div>
        </div>

        <div class="row justify-content-center" v-if="servers.length <= 0">
            <div class="col-lg-6">
                <div class="text-center mb-5">
                    <h4>You don't have a server yet!</h4>
                    <p class="text-muted">Deploy your own Minecraft server! Select the appropriate plan for you, and we'll handle the rest.</p>
                </div>
            </div>
        </div>

        <div class="row justify-content-center" v-if="servers.length <= 0">
            <div class="col-xl-3 col-md-6">
                <div class="card plan-box">
                    <div class="card-body p-4">
                        <div class="media">
                            <div class="media-body">
                                <h5>FREE Tier</h5>
                                <p class="text-muted">Best option for those who want to play privately for free.</p>
                            </div>
                            <div class="ml-3">
                                <i class="bx bxs-joystick h1 text-primary"></i>
                            </div>
                        </div>
                        <div class="py-4">
                            <h2><sup><small></small></sup> £0<span class="font-size-13"> /Per month</span></h2>
                        </div>
                        <div class="text-center plan-btn">
                            <a href="#" class="btn btn-primary btn-sm waves-effect waves-light">DEPLOY NOW</a>
                        </div>

                        <div class="plan-features mt-5">
                            <p><i class="bx bx-checkbox-square text-primary mr-2"></i> 512MB RAM</p>
                            <p><i class="bx bx-checkbox-square text-primary mr-2"></i> 10 Player Slots</p>
                            <p><i class="bx bx-checkbox-square text-primary mr-2"></i> Metered SSD Storage</p>
                            <p><i class="bx bx-checkbox-square text-primary mr-2"></i> Always On* Technology</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-3 col-md-6">
                <div class="card plan-box">
                    <div class="card-body p-4">
                        <div class="media">
                            <div class="media-body">
                                <h5>Paid Plans</h5>
                                <p class="text-muted">Providing maximum performance for your server.</p>
                            </div>
                            <div class="ml-3">
                                <i class="bx bxs-chip h1 text-primary"></i>
                            </div>
                        </div>
                        <div class="py-4">
                            <h2><sup><small>From</small></sup> £3.98<span class="font-size-13"> /Per month</span></h2>
                        </div>
                        <div class="text-center plan-btn">
                            <a href="pricing.html" class="btn btn-primary btn-sm waves-effect waves-light">SELECT A PLAN</a>
                        </div>

                        <div class="plan-features mt-5">
                            <p><i class="bx bx-checkbox-square text-primary mr-2"></i> 1GB-12GB RAM</p>
                            <p><i class="bx bx-checkbox-square text-primary mr-2"></i> Unlimited Player Slots</p>
                            <p><i class="bx bx-checkbox-square text-primary mr-2"></i> Unmetered NVMe Storage</p>
                            <p><i class="bx bx-checkbox-square text-primary mr-2"></i> 24/7 Always On</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- end row -->
        <div class="row" v-if="servers.length > 0">
           <div class="col-12">
              <div class="text-center my-3">
                 <button type="button" class="btn btn-success waves-effect waves-light">
                 <i class="bx bx-rocket font-size-16 align-middle mr-2"></i> Create New Server
                 </button>
              </div>
           </div>
           <!-- end col-->
        </div>
     </div>
  </div>
</template>

<script>
export default{
  name: 'Servers',
  data () {
    return {
      servers: []
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/management/Servers.vue